module.exports = __webpack_public_path__ + "img/rabbits.3be5b90.png";